import { Component, viewChild } from '@angular/core';
import { UiButtonComponent, UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';

/**
 * بیانیه ریسک محاسبات پرتفوی — the sheet behind the menu's بیانیه ریسک row.
 *
 * It says one thing: the figures on the portfolio are approximate and can
 * differ from what a trade finally settles at. So it carries no choice and no
 * state — reading it is the whole interaction, and متوجه شدم is an
 * acknowledgement rather than a save.
 *
 * The text is deliberately long enough to scroll, which the acceptance criteria
 * ask for; it scrolls in its own region rather than the sheet's so متوجه شدم
 * stays on screen while the trader reads.
 */
@Component({
	selector: 'app-portfolio-risk-statement-bottom-sheet',
	imports: [BottomSheetComponent, UiButtonComponent, UIIconComponent],
	templateUrl: './portfolio-risk-statement-bottom-sheet.component.html',
	host: {
		'data-cy': 'portfolio-risk-statement-bottom-sheet'
	}
})
export class PortfolioRiskStatementBottomSheetComponent {
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	/** متوجه شدم — the acceptance criteria's way back to the portfolio. */
	onAcknowledgeClick(): Promise<void> {
		return this.close();
	}
}
